/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import './RoutesChart.scss';
import RoutePlanLeft from './RoutesChart/RoutePlanLeft';
import {
  COLORS,
  DATE_BACKEND_FORMAT,
  FULL_DATE_FORMAT,
  ORDER_STATUSES,
  STEP_TYPE,
  ORDER_STATUSES_FAILED,
  ORDER_DELIVERY_STATUS_COMPLETED,
  ORDER_PICKUP_STATUS_COMPLETED,
  STEP_STATUS,
} from '../constants';
import { Button, DatePicker, Input, message, notification, Spin, Select } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import range from 'lodash/range';
import findIndex from 'lodash/findIndex';
import cloneDeep from 'lodash/cloneDeep';
import { chain, sortBy, uniq, forEach } from 'lodash';
import dayjs from 'dayjs';
import { ReactSVG } from 'react-svg';
import { DragDropContext } from '@hello-pangea/dnd';
import DriverTime from './RoutesChart/DriverTime';
import { v4 as uuidv4 } from 'uuid';
import Cookies from 'js-cookie';

import {
  doDispatchRoutes,
  doGetLogGMPRO,
  doGetRoutesByDate,
  doOptimizeRoutesByDate,
  doOptimizeRoutesGmproByDate,
  doReorderOrdersForRoutes,
} from '../modules/routes/stores/thunk';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { selectAllRoutes } from '../modules/routes/stores/slice';
import { doSynchronizeSchedulerForm } from '../modules/scheduler-forms/stores/thunk';
import {
  calculatePixelBetweenStops,
  getArrivalTime,
  getFinishTime,
  getFirstStartAndLastEnd,
  getWidthChart,
  isDiffTwoArrayStops,
  sortSteps,
} from '../utils/common';
import DriverList from './RoutesChart/DriverList';
import RouteMap from './RoutesChart/RouteMap';
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import UnScheduled from './RoutesChart/UnScheduled';
import { selectAllOrders } from '../modules/orders/stores/slice';
import { doChangeToDraft, doChangeToUnassigned, doGetOrders } from '../modules/orders/stores/thunk';
import RouteOrdersTable from '../components/Tables/RouteOrdersTable';
import SwapStopsToDriver from './RoutesChart/SwapStopsToDriver';
import { setShouldFitbounds } from '../redux/slice';
import StopClicked from './RoutesChart/StopClicked';
import SearchStops from './RoutesChart/SearchStops';
import { doGetOrderTickets } from '../modules/order-tickets/stores/thunk';
import { socket } from '../utils/socket';
import { useTranslation } from 'react-i18next';

const initStateTimeline = {
  minTimePx: null,
  maxTimePx: null,
  maxTimeMinutes: null,
  minTimeMinutes: null,
};

const initMultipleSteps = {
  toDriverId: undefined,
  index: undefined,
  steps: [],
  visibleModal: false,
  searchedRoutes: [],
  selectedRoute: undefined,
  index: undefined,
};

const InitOneHourPx = 300;

const RoutesChart = () => {
  const { t } = useTranslation(['routes', 'common']);
  const { type } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const query = Object.fromEntries(searchParams);
  const [api, contextHolder] = message.useMessage();

  // Configure global notification placement and offset from top
  useEffect(() => {
    notification.config({ placement: 'topRight', top: 72 });
  }, []);

  const dateCookie = Cookies.get('date');

  const routes = useSelector(selectAllRoutes);
  const orders = useSelector(selectAllOrders);
  const orderTickets = useSelector((state) => state.orderTickets.orderTickets);

  const { isFetching: isFetchingShift } = useSelector((state) => state.schedulerForm);

  const { isFetching: isFetchingRoute, action: actionRoute, status: statusRoute } = useSelector((state) => state.route);

  const { isFetching: isFetchingOrder, action: actionOrder, status: statusOrder } = useSelector((state) => state.order);

  const [date, setDate] = useState();
  const [oneHourPx, setOneHourPx] = useState(InitOneHourPx);
  const [isDragging, setIsDragging] = useState(false);
  const [solutions, setSolutions] = useState({});
  const [originalSolutions, setOriginalSolutions] = useState({});
  const [mapData, setMapData] = useState({});
  const [startTime, setStartTime] = useState('08:00');
  const [hourStart, setHourStart] = useState(8);
  const [hourEnd, setHourEnd] = useState(8);
  const [stateTimeLine, setStateTimeLine] = useState(initStateTimeline);
  const [ordersSelected, setOrdersSelected] = useState([]);
  const [isOptimize, setIsOptimize] = useState(false);
  const [selectedStep, setSelectedStep] = useState({});
  const [multipleStepState, setMultipleStepState] = useState(initMultipleSteps);
  const [hideDriverIds, setHideDriverIds] = useState([]);
  const [dragDriverIds, setDragDriverIds] = useState([]);
  const [allStops, setAllStops] = useState([]);
  const [searchStopsMap, setSearchStopsMap] = useState('');

  // ─── Draggable separator between map and chart ──────────────────────
  const [chartHeight, setChartHeight] = useState(200);
  const isDraggingSeparator = useRef(false);
  const startY = useRef(0);
  const startHeight = useRef(200);
  const wrapperRef = useRef(null);

  const onSeparatorMouseDown = useCallback(
    (e) => {
      e.preventDefault();
      isDraggingSeparator.current = true;
      startY.current = e.clientY;
      startHeight.current = chartHeight;
      document.body.style.cursor = 'row-resize';
      document.body.style.userSelect = 'none';
    },
    [chartHeight],
  );

  useEffect(() => {
    const onMouseMove = (e) => {
      if (!isDraggingSeparator.current) return;
      // Dragging down = shrink chart, dragging up = grow chart
      const delta = startY.current - e.clientY;
      const newHeight = Math.min(Math.max(startHeight.current + delta, 100), 600);
      setChartHeight(newHeight);
    };
    const onMouseUp = () => {
      if (!isDraggingSeparator.current) return;
      isDraggingSeparator.current = false;
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    };
    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
    return () => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
    };
  }, []);
  // ──────────────────────────────────────────────────────────────────

  const isFetching = isFetchingShift || isFetchingOrder || isOptimize || isFetchingRoute;

  // Compute how many unscheduled orders match the search filter
  const unscheduledSteps = solutions['unscheduled'] || [];
  const totalUnscheduled = unscheduledSteps.length;
  const matchedUnscheduled = useMemo(() => {
    if (!searchStopsMap) return totalUnscheduled;
    const query = searchStopsMap.toLowerCase();
    return unscheduledSteps.filter(
      (step) =>
        step.address?.toString().toLowerCase().match(query) ||
        step.driverName?.toString().toLowerCase().match(query) ||
        step.name?.toString().toLowerCase().match(query) ||
        step.orderCode?.toString().toLowerCase().match(query) ||
        step.partner?.toString().toLowerCase().match(query) ||
        step.volume?.toString().toLowerCase().match(query),
    ).length;
  }, [unscheduledSteps, searchStopsMap, totalUnscheduled]);
  const isFilterActive = searchStopsMap && searchStopsMap.length > 0 && matchedUnscheduled !== totalUnscheduled;

  const ordersInDate = orders.filter(
    (order) =>
      date &&
      dayjs(order.deliveryDate).format(DATE_BACKEND_FORMAT) === date?.format(DATE_BACKEND_FORMAT) &&
      ![ORDER_STATUSES.DRAFT, ORDER_STATUSES.GEOCODING, ORDER_STATUSES.ERROR].includes(order.status),
  );

  const getAllDataForPage = () => {
    if (!date) return;
    dispatch(doGetRoutesByDate({ date: date?.format(DATE_BACKEND_FORMAT) }));
    dispatch(doGetLogGMPRO({ date: date?.format(DATE_BACKEND_FORMAT) }));
    dispatch(
      doGetOrders({
        deliveryDateFrom: date?.format(DATE_BACKEND_FORMAT),
        deliveryDateTo: date?.format(DATE_BACKEND_FORMAT),
        take: 1000000,
      }),
    );
    setIsOptimize(false);
  };

  useEffect(() => {
    if (type) {
      setOrdersSelected([]);
      setSelectedStep({});
      setSearchStopsMap('');
    }
  }, [type]);

  useMemo(() => {
    getAllDataForPage();
    dispatch(doGetOrderTickets());
  }, [date]);

  useEffect(() => {
    // In demo mode, always use the date that has mock data
    const isDemoMode = process.env.REACT_APP_DEMO_MODE === 'true';
    const demoDate = '2026-02-06';

    if (isDemoMode) {
      setDate(dayjs(demoDate, DATE_BACKEND_FORMAT));
      Cookies.set('date', demoDate);
      if (!query?.date || query?.date !== demoDate) {
        setSearchParams({ date: demoDate });
      }
    } else if (query?.date) {
      setDate(dayjs(query?.date, DATE_BACKEND_FORMAT));
      Cookies.set('date', query?.date);
    } else if (dateCookie) {
      setDate(dateCookie ? dayjs(dateCookie, DATE_BACKEND_FORMAT) : dayjs());
    } else {
      setDate(dayjs());
      Cookies.set('date', dayjs().format(DATE_BACKEND_FORMAT));
    }
  }, [query?.date, dateCookie]);

  useEffect(() => {
    if (actionOrder === 'changeToUnassigned' && statusOrder === 'succeeded') {
      type === 'add-orders'
        ? navigate(`/admin/route-plans?date=${date?.format(DATE_BACKEND_FORMAT)}`)
        : dispatch(
            doGetOrders({
              deliveryDateFrom: date?.format(DATE_BACKEND_FORMAT),
              deliveryDateTo: date?.format(DATE_BACKEND_FORMAT),
              take: 1000000,
            }),
          );
      setOrdersSelected([]);
    }
    if (actionOrder === 'changeToDraft' && statusOrder === 'succeeded') {
      dispatch(
        doGetOrders({
          deliveryDateFrom: date?.format(DATE_BACKEND_FORMAT),
          deliveryDateTo: date?.format(DATE_BACKEND_FORMAT),
          take: 1000000,
        }),
      );
      setOrdersSelected([]);
    }
  }, [actionOrder, statusOrder]);

  useEffect(() => {
    if (actionRoute === 'optimizeByDate' && statusRoute === 'failed' && isOptimize) {
      setIsOptimize(false);
    }
  }, [actionRoute, statusRoute]);

  useEffect(() => {
    const dateFormat = date?.format(DATE_BACKEND_FORMAT);
    socket.connect();
    socket.on('routePlan', async (data) => {
      if (data.event === 'optimizing.completed' && data.payload.name == dateFormat) {
        console.log('routePlan.optimizing.completed');
        await getAllDataForPage();
        setIsOptimize(false);
      }

      if (data.event === 'optimizing.error' && data.payload.name == dateFormat) {
        console.log('routePlan.optimizing.error');
        setIsOptimize(false);
        notification.error({
          message: t('optimizeFailed'),
          description: data?.payload?.message,
          // top offset is controlled globally via notification.config in this component
        });
      }
    });
    return () => {
      socket.disconnect();
    };
  }, [date]);

  const handleSynchronize = async () => {
    await dispatch(doSynchronizeSchedulerForm({ date: date?.format(DATE_BACKEND_FORMAT) }));
    getAllDataForPage();
  };

  const handleOptimize = async () => {
    setIsOptimize(true);
    await dispatch(doOptimizeRoutesByDate({ date: date?.format(DATE_BACKEND_FORMAT) }));
  };

  const handleOptimizeGmpro = async () => {
    setIsOptimize(true);
    let ignoreOrders = [];
    if (searchStopsMap) {
      const unscheduleSteps = originalSolutions['unscheduled'];
      const matches = unscheduleSteps
        .filter((step) => {
          return (
            step.address?.toString().toLowerCase().match(searchStopsMap.toLowerCase()) ||
            step.driverName?.toString().toLowerCase().match(searchStopsMap.toLowerCase()) ||
            step.name?.toString().toLowerCase().match(searchStopsMap.toLowerCase()) ||
            step.orderCode?.toString().toLowerCase().match(searchStopsMap.toLowerCase()) ||
            step.partner?.toString().toLowerCase().match(searchStopsMap.toLowerCase()) ||
            step.volume?.toString().toLowerCase().match(searchStopsMap.toLowerCase())
          );
        })
        .map((step) => step.orderCode);

      const orderCodesIgnore = unscheduleSteps
        .filter((step) => !matches.includes(step.orderCode))
        .map((step) => step.orderCode);

      ignoreOrders = [...new Set([...ignoreOrders, ...orderCodesIgnore])];
    }
    await dispatch(
      doOptimizeRoutesGmproByDate({
        date: date?.format(DATE_BACKEND_FORMAT),
        hideDriverIds: hideDriverIds?.map((id) => id.toString()),
        ignoreOrders,
      }),
    );
  };

  const handleDispatch = () => {
    const routesToDispatchIds = routes.filter((route) => route.steps.length > 0)?.map((route) => route.id);
    dispatch(doDispatchRoutes({ ids: routesToDispatchIds }));
  };

  const getSummaryRoutes = () => {
    let stepsDone = 0;
    let stepsSkipped = 0;
    let stepsFailed = 0;
    let stepsTotal = 0;
    let workingMins = 0;
    let distance = 0;
    const totalOrders = [];
    routes?.forEach((route) => {
      if (hideDriverIds?.includes(route.driver.id)) return;
      route.steps
        ?.filter((step) => step.type !== STEP_TYPE.driver)
        .forEach((step) => {
          // Handle both single orderId and multiple orderIds
          const orderIds = step.orderIds || (step.orderId ? [step.orderId] : []);
          orderIds.forEach((orderId) => {
            const order = orders.find((o) => o.id === orderId);
            if (order) {
              totalOrders.push(order);

              if (step.order?.status === 'SKIPPED') {
                stepsSkipped += 1;
              } else if (step.order && ORDER_STATUSES_FAILED.includes(step.order.status)) {
                stepsFailed += 1;
              } else if (step.type === STEP_TYPE.delivery && ORDER_DELIVERY_STATUS_COMPLETED.includes(order?.status)) {
                stepsDone += 1;
              } else if (
                step.type === STEP_TYPE.pickup &&
                ORDER_PICKUP_STATUS_COMPLETED.includes(order?.pickupStatus)
              ) {
                stepsDone += 1;
              }
              stepsTotal += 1;
              workingMins += step.workingMins;
              distance += step.distance;
            }
          });
        });
    });

    return { stepsDone, stepsTotal, workingMins, distance, stepsSkipped, stepsFailed, totalOrders: totalOrders.length };
  };

  const summaryRoutes = getSummaryRoutes();

  const handleReorder = async () => {
    const drivers = [];
    const unscheduled = [];
    const allOrderIds = [];
    routes.map((route) => {
      const isDiff = isDiffTwoArrayStops(solutions[route.driver.id], originalSolutions[route.driver.id]);
      if (isDiff) {
        const driver = { driverId: route.id, steps: [] };
        solutions[route.driver.id].map((step) => {
          if (step.type.toUpperCase() === 'PICKUP') {
            step.orderIds.forEach((id) => {
              const order = orders.find((order) => order.id === id);

              if (
                order &&
                order.status != 'SKIPPED' &&
                ((step.type.toUpperCase() === 'PICKUP' && order.pickupStatus != 'COLLECTED') ||
                  (step.type.toUpperCase() === 'DELIVERY' && order.status != 'COMPLETED'))
              ) {
                driver.steps.push(`${order.id}_${step.type.toUpperCase()}`);
                allOrderIds.push(order.id);
              }
            });
          } else {
            // Delivery step - handle multiple orderIds
            step.orderIds?.forEach((orderId) => {
              const order = orders.find((order) => order.id === orderId);

              if (
                order &&
                order.status != 'SKIPPED' &&
                ((step.type.toUpperCase() === 'PICKUP' && order.pickupStatus != 'COLLECTED') ||
                  (step.type.toUpperCase() === 'DELIVERY' && order.status != 'COMPLETED'))
              ) {
                driver.steps.push(`${order.id}_${step.type.toUpperCase()}`);
                allOrderIds.push(order.id);
              }
            });
          }
        });
        drivers.push(driver);
      }
    });
    if (drivers.length === 0) return;

    const isDiffUnscheduled = isDiffTwoArrayStops(solutions['unscheduled'], originalSolutions['unscheduled']);
    if (isDiffUnscheduled) {
      solutions['unscheduled'].map((step) => {
        const order = orders.find((order) => step.orderIds.includes(order.id));
        if (
          order &&
          order.status != 'SKIPPED' &&
          ((step.type.toUpperCase() === 'PICKUP' && order.pickupStatus != 'COLLECTED') ||
            (step.type.toUpperCase() === 'DELIVERY' && order.status != 'COMPLETED'))
        ) {
          unscheduled.push(order.id);
          allOrderIds.push(order.id);
        }
      });
    }
    // setIsOptimize(true);

    console.log('Reorder orders for routes', {
      date: date?.format(DATE_BACKEND_FORMAT),
      drivers,
      unscheduled,
      allOrderIds,
    });

    await dispatch(
      doReorderOrdersForRoutes({
        date: date?.format(DATE_BACKEND_FORMAT),
        routes: drivers,
        unscheduled: uniq(unscheduled),
        allOrderIds: uniq(allOrderIds),
      }),
    );
  };

  const moveSteps = () => {
    const updatedSolutions = cloneDeep(solutions);
    let moveIndex = multipleStepState.index;
    let targetDriverId = multipleStepState.toDriverId;
    const sortedAndGroupedData = chain(multipleStepState.steps || [])
      .sortBy('orderNumber')
      .groupBy('driverId')
      .value();

    if (typeof moveIndex !== 'number') {
      targetDriverId = targetDriverId === 'unscheduled' ? targetDriverId : targetDriverId;
      moveIndex = 0;
    }
    const moveAfterStep = { ...updatedSolutions[targetDriverId][moveIndex] };
    Object.keys(sortedAndGroupedData).forEach((fromDriverId) => {
      let sourceClone = [...updatedSolutions[fromDriverId]];

      const stepsNeedMove = sortBy(sortedAndGroupedData[fromDriverId], 'type');
      let stepsToMove = [];

      stepsNeedMove.forEach((step) => {
        if (step.type === STEP_TYPE.pickup) {
          const stepPushPickup = sourceClone.find(
            (stepSc) => step.id === stepSc.id && stepSc.type === STEP_TYPE.pickup,
          );
          const stepsPush = [stepPushPickup];
          const orderIds = step.orderIds;

          orderIds.forEach((id) => {
            stepsPush.push(sourceClone.find((step) => step.orderId === id && step.type === STEP_TYPE.delivery));
          });
          stepsToMove = [...stepsToMove, ...stepsPush];
        } else {
          const stepPushDelivery = sourceClone.find(
            (stepSc) => step.id === stepSc.id && stepSc.type === STEP_TYPE.delivery,
          );

          stepsToMove.push(stepPushDelivery);

          const stepPickup = sourceClone.find(
            (stepSc) => stepSc.orderIds?.includes(stepPushDelivery.orderId) && stepSc.type === STEP_TYPE.pickup,
          );
          stepsToMove.push({
            ...stepPickup,
            id: stepPickup.orderIds.length > 1 ? uuidv4() : stepPickup.id,
            orderIds: [stepPushDelivery.orderId],
          });

          if (stepPushDelivery.orderIds.length > 1) {
            sourceClone = sourceClone.map((sc) => {
              if (stepPickup.id === sc.id) {
                return {
                  ...sc,
                  orderIds: sc.orderIds.filter((id) => id !== stepPushDelivery.orderId),
                };
              }
              return sc;
            });
          }
        }
      });

      sourceClone = sourceClone.filter((step) => {
        return !stepsToMove.some((moveStep) => step.id === moveStep.id && step.type === moveStep.type);
      });

      const targetClone = fromDriverId === targetDriverId ? [...sourceClone] : [...updatedSolutions[targetDriverId]];

      moveIndex = targetClone.findIndex((step) => step.id === moveAfterStep.id && step.type === moveAfterStep.type);

      const pushData = sortBy(stepsToMove, 'type');

      pushData.reverse().forEach((step) => {
        moveIndex++;
        targetClone.splice(moveIndex, 0, {
          ...step,
          marginLeft: 8,
        });
      });

      updatedSolutions[targetDriverId] = targetClone;

      if (fromDriverId !== targetDriverId) {
        updatedSolutions[fromDriverId] = sourceClone;
      }
    });

    setSolutions(updatedSolutions);
    setMultipleStepState(initMultipleSteps);
  };

  const selectedMultipleSteps = (step, driverId) => {
    const cloneSteps = [...multipleStepState.steps];
    const indexStep = cloneSteps.findIndex(
      (s) => s.stepId === step.stepId && s.type === step.type && s.driverId === driverId,
    );
    if (indexStep > -1) {
      cloneSteps.splice(indexStep, 1);
    } else {
      cloneSteps.unshift({ ...step, driverId });
    }
    setMultipleStepState({ ...multipleStepState, steps: cloneSteps });
  };

  const onClickStep = (step) => {
    // click close step
    if (!step) {
      setSelectedStep({});
      return;
    }

    if (selectedStep.id === step.id && selectedStep.type === step.type) {
      setSelectedStep({});
    } else {
      setSelectedStep({ id: step.id, type: step.type });
    }
  };

  const hours = range(hourStart, hourEnd + 2);
  const minutes = range(0, (hourEnd - hourStart) * 2 + 2);

  useEffect(() => {
    if (routes?.length) {
      const [startAt, endAt] = getFirstStartAndLastEnd(routes);
      const startHour = startAt && startAt?.split(':')[0];
      setHourStart(Number(startHour));
      const endHour = endAt && endAt?.split(':')[0];
      setHourEnd(Number(endHour));
      const startHourFull = `${startHour}:00`;
      setStartTime(startHourFull);
      if (stateTimeLine.maxTimePx || stateTimeLine.minTimePx) {
        if (stateTimeLine.minTimeMinutes) {
          const pxScroll = convertMinutesToPixel(stateTimeLine.minTimeMinutes, oneHourPx);
          containerTimelineRef.current.scrollTo({
            left: pxScroll - 80,
          });
        }
        setStateTimeLine(initStateTimeline);
      }
    }
  }, [routes, oneHourPx, date]);
  const onDragStart = () => {
    setIsDragging(true);
  };

  const isHasRouteStarted = useMemo(() => {
    return routes?.some((route) => route.steps?.some((step) => step.status === 'COMPLETED'));
  }, [routes]);

  const onDragEnd = (result) => {
    setIsDragging(false);
    const { source, destination } = result;
    if (!destination) return;
    if (source.droppableId === 'unscheduled' && destination.droppableId === 'unscheduled') return;

    const newDragDriverIds = [
      ...new Set([...dragDriverIds, source.droppableId, destination.droppableId].filter((id) => id !== 'unscheduled')),
    ];

    setDragDriverIds(newDragDriverIds);

    if (source.droppableId === destination.droppableId) {
      if (destination.index === source.index) return;
      if (destination.droppableId?.includes('assign') || destination.droppableId === 'unscheduled') return;

      const steps = solutions[source.droppableId];
      const sourceClone = [...steps];
      const stop = sourceClone[source.index];
      const type = stop.type === STEP_TYPE.pickup ? STEP_TYPE.delivery : STEP_TYPE.pickup;
      const stopOrderIds = stop.orderIds || [];

      if (stop.type === STEP_TYPE.delivery) {
        // For delivery, check if any orderId in stop.orderIds has a pickup before destination
        let isFalse = false;
        forEach(stopOrderIds, (orderId) => {
          if (isFalse) return;
          const stopPickupIndex = findIndex(sourceClone, (s) => s.orderIds?.includes(orderId) && s.type === type);
          if (stopPickupIndex > -1) {
            isFalse = destination.index <= stopPickupIndex;
          }
        });
        if (isFalse) {
          api.open({
            type: 'error',
            content: t('dropoffBeforePickup'),
            style: { marginTop: '52px' },
          });
          return;
        }
      } else {
        // For pickup, check if any orderId in stop.orderIds has a delivery after destination
        let isFalse = false;
        forEach(stopOrderIds, (orderId) => {
          if (isFalse) return;
          const stopDeliveryIndex = findIndex(sourceClone, (s) => s.orderIds?.includes(orderId) && s.type === type);
          if (stopDeliveryIndex > -1) {
            isFalse = destination.index >= stopDeliveryIndex;
          }
        });
        if (isFalse) {
          api.open({
            type: 'error',
            content: t('dropoffBeforePickup'),
            style: { marginTop: '52px' },
          });
          return;
        }
      }

      // Simply move the single step without moving related steps
      const [removed] = sourceClone.splice(source.index, 1);
      sourceClone.splice(destination.index, 0, {
        ...removed,
        duration: 20,
        marginLeft: 8,
      });

      const newSolutions = { ...solutions, [source.droppableId]: sourceClone };
      setSolutions(newSolutions);
    } else {
      moveStep(source, destination);
    }
  };

  const moveStep = (droppableSource, droppableDestination) => {
    const stepsSource = solutions[droppableSource.droppableId];
    const stepsDestination = solutions[droppableDestination.droppableId];
    const sourceClone = [...stepsSource];
    const destClone = [...stepsDestination];
    const stop = sourceClone[droppableSource.index];
    const type = stop.type === STEP_TYPE.pickup ? STEP_TYPE.delivery : STEP_TYPE.pickup;
    const newSolutions = { ...solutions };

    if (stop.type === STEP_TYPE.pickup) {
      const orderIds = stop.orderIds || [];

      // Remove pickup from source route
      const [removedPickup] = sourceClone.splice(droppableSource.index, 1);

      // Split related delivery steps in source route:
      // - remove these orderIds from original delivery's orderIds
      // - create new delivery step(s) that will move with this pickup
      const deliveryInfos = [];
      sourceClone.forEach((s, idx) => {
        if (s.type === type && s.orderIds?.some((orderId) => orderIds.includes(orderId))) {
          const intersectionOrderIds = s.orderIds.filter((orderId) => orderIds.includes(orderId));
          const remainingOrderIds = s.orderIds.filter((orderId) => !orderIds.includes(orderId));
          deliveryInfos.push({ index: idx, step: s, intersectionOrderIds, remainingOrderIds });
        }
      });

      // New delivery steps that move with this pickup (one per affected delivery step)
      const newDeliverySteps = deliveryInfos
        .filter((info) => info.intersectionOrderIds.length > 0)
        .map((info) => ({
          ...info.step,
          id: uuidv4(),
          orderIds: info.intersectionOrderIds,
          marginLeft: 8,
        }));

      // Update/remove original delivery steps in source route
      const sortedInfos = [...deliveryInfos].sort((a, b) => b.index - a.index);
      sortedInfos.forEach((info) => {
        if (info.remainingOrderIds.length === 0) {
          // No orderIds left -> remove delivery step
          sourceClone.splice(info.index, 1);
        } else {
          // Keep delivery step with remaining orderIds
          sourceClone.splice(info.index, 1, {
            ...info.step,
            orderIds: info.remainingOrderIds,
          });
        }
      });

      // Insert / merge pickup into destination route
      const destPickupIndex = destClone.findIndex(
        (dest) =>
          dest.lat === removedPickup.lat &&
          dest.lng === removedPickup.lng &&
          dest.locationId === removedPickup.locationId,
      );
      const destPickup = destPickupIndex === -1 ? null : destClone[destPickupIndex];
      let pickupIndexInDest;

      if (destPickup) {
        destClone.splice(destPickupIndex, 1, {
          ...destPickup,
          // duration: 10,
          orderIds: [...destPickup.orderIds, ...orderIds],
        });
        pickupIndexInDest = destPickupIndex;
      } else {
        destClone.splice(droppableDestination.index, 0, {
          ...removedPickup,
          id: uuidv4(),
          orderIds: [...orderIds],
          marginLeft: 8,
          // width: '20px',
        });
        pickupIndexInDest = droppableDestination.index;
      }

      // Insert new delivery step(s) right after the pickup in destination route
      newDeliverySteps.forEach((deliveryStep, idx) => {
        destClone.splice(pickupIndexInDest + 1 + idx, 0, {
          ...deliveryStep,
          marginLeft: 8,
        });
      });
    } else {
      // Delivery step
      const orderIds = stop.orderIds || [];
      const [removed] = sourceClone.splice(droppableSource.index, 1);
      destClone.splice(droppableDestination.index, 0, {
        ...removed,
        id: `${removed.id}-${removed.type}`,
        marginLeft: 8,
      });

      // Find pickup steps for all orderIds in this delivery
      orderIds.forEach((orderId) => {
        const stopPickupIndex = findIndex(sourceClone, (s) => s.orderIds?.includes(orderId) && s.type === type);
        if (stopPickupIndex > -1) {
          const stopPickup = sourceClone[stopPickupIndex];
          const pickupOrderIds = stopPickup.orderIds || [];
          if (pickupOrderIds.length === 1) {
            const destinationIndex = droppableDestination.index;
            const [removedLeft] = sourceClone.splice(stopPickupIndex, 1);
            destClone.splice(destinationIndex, 0, {
              ...removedLeft,
              id: `${removedLeft.id}-${removedLeft.type}`,
              marginLeft: 8,
              orderIds: [orderId],
            });
          } else if (pickupOrderIds.length > 1) {
            const destinationIndex =
              type === STEP_TYPE.pickup ? droppableDestination.index : droppableDestination.index + 1;
            const orderIdIndex = findIndex(pickupOrderIds, (id) => id === orderId);
            pickupOrderIds.splice(orderIdIndex, 1);
            sourceClone.splice(stopPickupIndex, 1, {
              ...stopPickup,
              orderIds: pickupOrderIds,
              id: uuidv4(),
              marginLeft: 8,
            });
            destClone.splice(destinationIndex, 0, {
              ...stopPickup,
              orderIds: [orderId],
              marginLeft: 8,
              id: uuidv4(),
            });
          }
        }
      });
    }
    newSolutions[droppableSource.droppableId] = sourceClone;
    newSolutions[droppableDestination.droppableId] = destClone;
    setSolutions(newSolutions);
  };

  const handleCancelMultiStops = () => {
    setMultipleStepState(initMultipleSteps);
  };

  const onSelectChangeAddOrders = (newSelectedRowKeys) => {
    setOrdersSelected(newSelectedRowKeys);
  };

  const changeOrdersToUnassigned = async () => {
    await dispatch(
      doChangeToUnassigned({
        orderCodes: ordersSelected,
      }),
    );

    await getAllDataForPage();
  };

  const changeOrdersToDraft = async () => {
    await dispatch(
      doChangeToDraft({
        orderCodes: ordersSelected,
      }),
    );
    await getAllDataForPage();
  };

  const handleKeyUp = (event) => {
    if (event.key === 'Meta' || event.key === 'Control' || event.key === 'Shift') {
      // if (multipleStepState.steps?.length > 0) {
      //   setMultipleStepState({
      //     ...multipleStepState,
      //     visibleModal: true,
      //   });
      // }
    }
  };

  useEffect(() => {
    window.addEventListener('keyup', handleKeyUp);
    return () => {
      window.removeEventListener('keyup', handleKeyUp);
    };
  }, [multipleStepState, stateTimeLine]);

  const formatSolutions = () => {
    console.log('[formatSolutions] Starting with routes:', routes?.length, routes);
    const solutionsTmp = {};
    const mapDataTmp = {};
    const unassignOrders = orders.filter((o) => o.status === 'UNASSIGNED');
    const allStopsTmp = [];

    const stepsUnassigned = [];
    let indexUnassigned = 1;
    for (let index = 0; index < unassignOrders.length; index++) {
      const order = unassignOrders[index];
      const ticketNames = order?.tickets?.map((t) => orderTickets?.find((ot) => ot.id === t)?.name) || [];
      if (order) {
        const paramsStepPickup = {
          id: `${order.orderCode}-pickup`,
          stepId: null,
          orderCode: order.orderCode,
          name: order.pickupName,
          location: order.pickupName,
          address: order.pickupAddress,
          lat: order.pickupAddressLat,
          lng: order.pickupAddressLng,
          startTime: order?.pickupTimeStart,
          partner: order?.partner,
          volume: order?.volume,
          type: STEP_TYPE.pickup,
          endTime: order?.pickupTimeEnd,
          status: order.status,
          index: indexUnassigned,
          orderNumber: indexUnassigned,
          duration: order.pickupDuration,
          orderId: order.id,
          orderIds: [order.id],
          orderCode: order.orderCode,
          deliveryName: order.deliveryName,
          orderTypes: order.types,
          partner: order?.partner,
          driverName: 'Unscheduled',
          volume: order?.volume,
          color: '#606060',
          routeId: 'unscheduled',
          unscheduledReason: order.unscheduledReason,
          ticketNames: ticketNames || [],
        };
        const paramsStepDelivery = {
          id: `${order.orderCode}-delivery`,
          stepId: null,
          orderCode: order.orderCode,
          name: order.deliveryName,
          location: order.deliveryName,
          address: order.deliveryAddress,
          lat: order.deliveryAddressLat,
          lng: order.deliveryAddressLng,
          startTime: order?.deliveryTimeStart,
          type: STEP_TYPE.delivery,
          endTime: order?.deliveryTimeEnd,
          status: order.status,
          index: indexUnassigned + 1,
          orderNumber: indexUnassigned + 1,
          duration: order.deliveryDuration,
          orderId: order.id,
          orderIds: [order.id],
          orderCode: order.orderCode,
          deliveryName: order.deliveryName,
          orderTypes: order.types,
          partner: order?.partner,
          volume: order?.volume,
          driverName: 'Unscheduled',
          color: '#606060',
          routeId: 'unscheduled',
          ticketNames: ticketNames || [],
          unscheduledReason: order.unscheduledReason,
        };
        stepsUnassigned.push(paramsStepPickup);
        stepsUnassigned.push(paramsStepDelivery);
        allStopsTmp.push(paramsStepPickup);
        allStopsTmp.push(paramsStepDelivery);
        indexUnassigned += 2;
      }
    }
    const rsUnassignedStops = {
      steps: stepsUnassigned,
      color: '#606060',
    };

    solutionsTmp['unscheduled'] = stepsUnassigned;

    mapDataTmp['unscheduled'] = rsUnassignedStops;

    routes.forEach((route) => {
      console.log('[formatSolutions] Processing route', route.id, 'with', route.steps?.length, 'raw steps');
      const steps = calculatePixelBetweenStops(
        route?.steps?.map((step) => ({
          ...step,
          arrivalTime: getArrivalTime(step),
          finishTime: getFinishTime(step),
        })) || [],
        route,
        oneHourPx,
      );
      console.log('[formatSolutions] After calculatePixelBetweenStops:', steps.length, 'steps');
      const driver = route.driver;
      const newSteps = [];
      const color = '#' + COLORS[driver.id % (COLORS.length - 1)];
      let indexStep = 1;

      if (steps.length > 0) {
        for (let index = 0; index < steps.length; index++) {
          const step = steps[index];
          if (!step) {
            console.log('[formatSolutions] WARNING: step', index, 'is null/undefined, skipping');
            continue; // Changed from return to continue
          }

          const width = step.arrivalTime ? getWidthChart(step.arrivalTime, step.finishTime, oneHourPx) : 1;

          const orderData = orders.find((o) => o.id === step.orderId);
          const ticketNames = orderData?.tickets?.map((t) => orderTickets?.find((ot) => ot.id === t)?.name) || [];

          const stepResponse = {
            id: `${step.id}-${step.type}`,
            stepId: step.id,
            orderNumber: step.orderNumber,
            driverName: driver?.name,
            name: step.type === STEP_TYPE.pickup ? step.order?.pickupName : step.order?.deliveryName,
            location: step.order?.pickupName,
            address: step.order?.pickupAddress,
            lat: step.order?.pickupAddressLat,
            lng: step.order?.pickupAddressLng,
            arrivalTime: step.arrivalTime,
            finishTime: step.finishTime,
            startTime: step.order?.deliveryTimeStart,
            endTime: step.order?.deliveryTimeEnd,
            status: step.status,
            type: step.type,
            distance: step.distance,
            orderNumber: step.orderNumber,
            index: indexStep,
            duration: step.type === STEP_TYPE.pickup ? step.order?.pickupDuration : step.order?.deliveryDuration,
            marginLeft: step.marginLeft,
            width,
            orderIds: [step.orderId],
            orderCode: step.order?.orderCode,
            deliveryName: step.order?.deliveryName,
            orderRef: step.order?.orderRef,
            orderStatus: step.order?.status,
            pickupStatus:
              step.order?.status === ORDER_STATUSES.SKIPPED ? ORDER_STATUSES.SKIPPED : step.order?.pickupStatus,
            driverName: driver?.name,
            travelMins: step.travelMins || 0,
            workingMins: step.workingMins || 0,
            waitingMins: step.waitingMins || 0,
            color,
            orderTypes: step.order?.types,
            partner: orderData?.partner,
            volume: orderData?.volume,
            logs: step.order?.logs || [],
            order: step.order,
            orderType: step.order?.orderType,
            ticketNames: ticketNames || [],
            collectedItems: step.collectedItems || [],
          };

          if (step.type === STEP_TYPE.delivery) {
            stepResponse.location = step.order?.deliveryName;
            stepResponse.address = step.order?.deliveryAddress;
            stepResponse.lat = step.order?.deliveryAddressLat;
            stepResponse.lng = step.order?.deliveryAddressLng;

            let isCompletedDelivery = step.status === STEP_STATUS.COMPLETED;
            let sameDelivery = false;
            const orderIds = [...stepResponse.orderIds];

            if (index < steps.length - 1) {
              do {
                const currentNext = steps[index];
                const stepNext = steps[index + 1];
                if (!isCompletedDelivery && stepNext?.type === STEP_TYPE.delivery && stepNext?.order)
                  isCompletedDelivery = stepNext.status === STEP_STATUS.COMPLETED;
                const widthNextStep = stepNext?.arrivalTime
                  ? getWidthChart(stepNext.arrivalTime, stepNext.finishTime, oneHourPx)
                  : 1;
                sameDelivery =
                  stepNext &&
                  stepNext.type === STEP_TYPE.delivery &&
                  currentNext.status === stepNext.status &&
                  currentNext.order?.deliveryAddressLat === stepNext.order?.deliveryAddressLat &&
                  currentNext.order?.deliveryAddressLng === stepNext.order?.deliveryAddressLng &&
                  currentNext.order?.deliveryPhone === stepNext.order?.deliveryPhone &&
                  currentNext.order?.deliveryName === stepNext.order?.deliveryName;

                if (sameDelivery) {
                  stepResponse.duration += stepNext.duration;
                  stepResponse.distance += stepNext.distance;
                  stepResponse.travelMins += stepNext.travelMins;
                  stepResponse.workingMins += stepNext.workingMins;
                  stepResponse.waitingMins = stepNext.waitingMins;
                  stepResponse.finishTime = stepNext.finishTime;
                  stepResponse.width += widthNextStep;
                  stepResponse.marginLeft += stepNext.marginLeft;
                  orderIds.push(stepNext.orderId);
                  index++;
                }
              } while (sameDelivery);
            }
            stepResponse.status = isCompletedDelivery ? 'COMPLETED' : 'IN_PROGRESS';
            stepResponse.id = `${orderIds.length}||${stepResponse.id}-${orderIds.length}`;
            stepResponse.orderIds = orderIds;
          } else if (step.type === STEP_TYPE.pickup) {
            let isCompletedPickup =
              stepResponse.orderStatus === ORDER_STATUSES.SKIPPED ||
              stepResponse.pickupStatus === ORDER_STATUSES.COLLECTED ||
              stepResponse.pickupStatus === ORDER_STATUSES.PICKUP_FAILED;

            delete stepResponse.orderStatus; // No need
            delete stepResponse.pickupStatus; // No need
            let partner = stepResponse?.order?.partner || '';
            let samePickup = false;
            const orderIds = [...stepResponse.orderIds];
            if (index < steps.length - 1) {
              do {
                const currentNext = steps[index];
                const stepNext = steps[index + 1];
                if (!isCompletedPickup && stepNext?.type === STEP_TYPE.pickup && stepNext?.order)
                  isCompletedPickup =
                    stepNext.order.status === ORDER_STATUSES.SKIPPED ||
                    stepNext.order.pickupStatus === ORDER_STATUSES.COLLECTED ||
                    stepNext.order.pickupStatus === ORDER_STATUSES.PICKUP_FAILED;
                const widthNextStep = stepNext?.arrivalTime
                  ? getWidthChart(stepNext.arrivalTime, stepNext.finishTime, oneHourPx)
                  : 1;
                samePickup =
                  stepNext &&
                  stepNext.type === STEP_TYPE.pickup &&
                  currentNext.status === stepNext.status &&
                  currentNext.order?.pickupAddressLat === stepNext.order?.pickupAddressLat &&
                  currentNext.order?.pickupAddressLng === stepNext.order?.pickupAddressLng &&
                  currentNext.order?.pickupPhone === stepNext.order?.pickupPhone;

                if (samePickup) {
                  if (stepNext.order?.partner) {
                    const partnerList = partner
                      .split(',')
                      .map((p) => p.trim())
                      .filter(Boolean);

                    if (!partnerList.includes(stepNext.order?.partner)) {
                      partnerList.push(stepNext.order?.partner);
                      partner = partnerList.join(', ');
                    }
                  }
                  stepResponse.duration += stepNext.duration;
                  stepResponse.distance += stepNext.distance;
                  stepResponse.travelMins += stepNext.travelMins;
                  stepResponse.workingMins += stepNext.workingMins;
                  stepResponse.waitingMins = stepNext.waitingMins;
                  stepResponse.finishTime = stepNext.finishTime;
                  stepResponse.width += widthNextStep;
                  stepResponse.marginLeft += stepNext.marginLeft;
                  orderIds.push(stepNext.orderId);
                  index++;
                }
              } while (samePickup);
            }
            stepResponse.status = isCompletedPickup ? 'COMPLETED' : 'IN_PROGRESS';
            stepResponse.id = `${orderIds.length}||${stepResponse.id}-${orderIds.length}`;
            stepResponse.orderIds = orderIds;
            stepResponse.partner = partner;
          }
          newSteps.push(stepResponse);
          allStopsTmp.push(stepResponse);
          indexStep += 1;
        }
      }

      solutionsTmp[route.driver.id] = newSteps;
      solutionsTmp[`assign_${route.driver.id}`] = [];
      console.log(
        '[formatSolutions] Route',
        route.id,
        'polyline:',
        route.polyline?.substring(0, 50),
        'steps:',
        newSteps?.length,
      );
      mapDataTmp[route.driver.id] = {
        polyline: newSteps?.length > 0 ? route.polyline : null,
        steps: newSteps,
        color: color,
        endAddressLat: route.endAddressLat,
        endAddressLng: route.endAddressLng,
        startAddressLat: route.startAddressLat,
        startAddressLng: route.startAddressLng,
      };
      console.log(
        '[formatSolutions] mapData for driver',
        route.driver.id,
        ':',
        mapDataTmp[route.driver.id].polyline?.substring(0, 50),
      );
    });
    setAllStops(allStopsTmp);

    if (selectedStep?.id) {
      setSelectedStep({});
    }

    if (dragDriverIds?.length > 0) {
      setDragDriverIds([]);
    }
    setSolutions(solutionsTmp);
    setOriginalSolutions(solutionsTmp);
    setMapData(mapDataTmp);
    dispatch(setShouldFitbounds(true));
  };

  const onHideDriver = (driverId) => {
    if (dragDriverIds.includes(driverId.toString())) {
      api.open({
        type: 'error',
        content: t('cannotHideWhileDragging'),
        style: { marginTop: '52px' },
      });
      return;
    }
    if (hideDriverIds?.includes(driverId)) {
      setHideDriverIds(hideDriverIds.filter((id) => id !== driverId));
    } else {
      setHideDriverIds([...hideDriverIds, driverId]);
    }
  };

  const revertDelivery = (driverId) => {
    setSolutions((prev) => {
      const original = prev?.[driverId] || [];
      if (original.length === 0) return prev;

      const next = [...original];
      const pickups = original.filter((s) => s.type === STEP_TYPE.pickup);

      pickups.forEach((pickup) => {
        const deliveries = original.filter((s) => s.type === STEP_TYPE.delivery && pickup.orderIds.includes(s.orderId));
        if (deliveries.length <= 1) return;

        const deliveryIdxs = original
          .map((s, i) => (s.type === STEP_TYPE.delivery && pickup.orderIds.includes(s.orderId) ? i : -1))
          .filter((i) => i >= 0);

        const reversed = [...deliveries].reverse();
        deliveryIdxs.forEach((idx, i) => {
          next[idx] = reversed[i];
        });
      });

      if (next.every((s, i) => s === original[i])) return prev;
      const newDragDriverIds = [...new Set([...dragDriverIds, driverId].filter((id) => id !== 'unscheduled'))];

      setDragDriverIds(newDragDriverIds);
      return { ...prev, [driverId]: next };
    });
  };

  useEffect(() => {
    formatSolutions();
  }, [routes, oneHourPx, orders]);

  const onChangeDate = (dateInput) => {
    setDate(dateInput);
    setSearchParams({ date: dateInput.format(DATE_BACKEND_FORMAT) });
    Cookies.set('date', dateInput.format(DATE_BACKEND_FORMAT));
  };

  const onZoomIn = () => {
    if (oneHourPx >= 1500) return;
    setOneHourPx((prev) => prev + 300);
  };

  const onZoomOut = () => {
    if (oneHourPx <= 300) return;
    setOneHourPx((prev) => prev - 300);
  };

  const isDispatchUpdated = useMemo(() => {
    return routes.some((route) => route.dispatched);
  }, [routes]);

  return (
    <Spin tip={t('common:loading')} spinning={isFetching}>
      {contextHolder}
      <div className="RoutesChart">
        <RoutePlanLeft deliveryDate={date} orders={ordersInDate} />
        {!type && (
          <div className="wrapper">
            <div className="select-date">
              <DatePicker
                onChange={onChangeDate}
                value={date}
                format={FULL_DATE_FORMAT}
                allowClear={false}
                size="large"
              />
            </div>
            <div className="search-stops-map">
              <Input
                allowClear
                placeholder={t('searchStop')}
                size="large"
                onChange={(e) => setSearchStopsMap(e.target.value)}
                value={searchStopsMap}
              />
            </div>
            <SearchStops stops={allStops} onClickStop={onClickStep} />
            <div className="wrapper-map">
              <RouteMap
                vehicles={routes}
                mapData={mapData}
                routes={routes}
                allOrders={orders}
                onClickStep={onClickStep}
                active={selectedStep}
                hideDriverIds={hideDriverIds}
                searchStopsMap={searchStopsMap}
              />
            </div>
            {/* Draggable separator handle */}
            <div className="drag-separator" onMouseDown={onSeparatorMouseDown}>
              <div className="drag-separator-line" />
            </div>
            <div className="wrapper-chart" style={{ height: chartHeight }}>
              <div className="ChartContent">
                <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart}>
                  {isFilterActive && (
                    <div className="optimize-filter-banner">
                      <span>
                        {t('ofOrdersMatch', {
                          matched: matchedUnscheduled,
                          total: totalUnscheduled,
                          search: searchStopsMap,
                        })}
                      </span>
                      <CloseOutlined className="clear-filter" onClick={() => setSearchStopsMap('')} />
                    </div>
                  )}
                  <div className="tbody unscheduled" style={{ width: '100%', height: '48px' }}>
                    <UnScheduled
                      zoom={oneHourPx}
                      onZoomIn={onZoomIn}
                      onZoomOut={onZoomOut}
                      steps={solutions['unscheduled']}
                      realSteps={solutions['unscheduled'] || []}
                      stepsHovered={{}}
                      setStepsHovered={() => {}}
                      onHoverStep={() => {}}
                      handleCloseStepPopup={() => {}}
                      isDragging={isDragging}
                      idsHides={[]}
                      onClickStep={onClickStep}
                      onClickHide={() => {}}
                      multipleStepState={multipleStepState}
                      selectedMultipleSteps={selectedMultipleSteps}
                      selectedStep={selectedStep}
                      searchStopsMap={searchStopsMap}
                    />
                  </div>
                  <div className="scrollCustom tbody">
                    <DriverTime hours={hours} oneHourPx={oneHourPx} />
                    <DriverList
                      isDragging={isDragging}
                      hours={hours}
                      oneHourPx={oneHourPx}
                      minutes={minutes}
                      startTime={startTime}
                      solutions={solutions}
                      routes={routes}
                      idsLock={[]}
                      onClickStep={onClickStep}
                      onClickRoute={() => {}}
                      multipleStepState={multipleStepState}
                      selectedMultipleSteps={selectedMultipleSteps}
                      selectedStep={selectedStep}
                      onClickHide={onHideDriver}
                      idsHide={hideDriverIds}
                      revertDelivery={revertDelivery}
                    />
                  </div>
                </DragDropContext>
              </div>
            </div>
            <div className="summary-routes">
              <p>
                <b>
                  {summaryRoutes.stepsDone} / {summaryRoutes.stepsTotal}
                </b>{' '}
                {t('stopsCompleted')}
              </p>
              <p>
                <b>
                  {summaryRoutes.stepsSkipped} / {summaryRoutes.stepsTotal}
                </b>{' '}
                {t('stopsSkipped')}
              </p>
              <p>
                <b>
                  {summaryRoutes.stepsFailed} / {summaryRoutes.stepsTotal}
                </b>{' '}
                {t('stopsFailed')}
              </p>
              <p>
                <b>
                  {summaryRoutes.stepsTotal} / {summaryRoutes.totalOrders}
                </b>{' '}
                {t('scheduled')}
              </p>
              <p>
                <b>{summaryRoutes.workingMins.toFixed(2)}</b> {t('workingMins')}
              </p>
              <p>
                <b>{(summaryRoutes.distance / 1000).toFixed(2)}</b> {t('totalKm')}
              </p>
            </div>
            <div className="actions-route-plan">
              <div className="left">
                <Button type="primary" onClick={handleSynchronize}>
                  {t('synchronize')}
                  <ReactSVG className="icon" src="/icons/sync.svg" />
                </Button>
              </div>
              <div className="right">
                {dragDriverIds?.length > 0 && (
                  <Button type="primary" ghost onClick={handleReorder}>
                    {t('common:apply')}
                    <ReactSVG className="icon" src="/icons/check.svg" />
                  </Button>
                )}
                {!dragDriverIds?.length && (
                  <Button type="primary" onClick={handleOptimizeGmpro}>
                    {isFilterActive
                      ? t('optimizeFiltered', { matched: matchedUnscheduled, total: totalUnscheduled })
                      : t('optimize')}
                    <ReactSVG className="icon" src="/icons/sync.svg" />
                  </Button>
                )}
                {/* <Button type="primary" onClick={handleOptimize}>
                  Optimize Route
                  <ReactSVG className="icon" src="/icons/sync.svg" />
                </Button> */}
                <Button
                  size="large"
                  className={`btn-dispatch-route ${isDispatchUpdated ? 'btn-dispatch-updated' : ''}`}
                  onClick={handleDispatch}
                >
                  {t('dispatchToDrivers')}
                  <ReactSVG className="icon" src="/icons/dispatch-to-driver.svg" />
                </Button>
              </div>
            </div>
          </div>
        )}
        {(type === 'add-orders' || type === 'orders') && (
          <div className="wrapper-orders">
            <h2 className="title">{type === 'add-orders' ? t('addOrders') : t('orders')}</h2>
            <div className="content">
              <div className="left">
                <RouteOrdersTable
                  solutions={solutions}
                  routes={routes}
                  showIndexVisit={type === 'orders'}
                  dataSource={orders.filter((o) =>
                    type === 'orders'
                      ? ![ORDER_STATUSES.DRAFT, ORDER_STATUSES.GEOCODING, ORDER_STATUSES.ERROR].includes(o.status)
                      : o.status === 'DRAFT',
                  )}
                  selectedRowKeys={ordersSelected}
                  onSelectChange={onSelectChangeAddOrders}
                  rowKey="orderCode"
                />
              </div>
              <div className="right"></div>
            </div>
            <div className="actions-orders">
              <div className="left"></div>
              <div className="right">
                {type === 'orders' && (
                  <>
                    <Link to={`/admin/route-plans/add-orders?date=${date?.format(DATE_BACKEND_FORMAT)}`}>
                      <Button type="primary">
                        {t('addOrders')}
                        <ReactSVG className="icon" src="/icons/plus.svg" />
                      </Button>
                    </Link>
                    <Button danger disabled={ordersSelected.length === 0} onClick={changeOrdersToDraft}>
                      {t('common:remove')} <CloseOutlined className="icon" />
                    </Button>
                    <Button danger disabled={ordersSelected.length === 0} onClick={changeOrdersToUnassigned}>
                      {t('unassign')} <CloseOutlined className="icon" />
                    </Button>
                  </>
                )}
                {type === 'add-orders' && (
                  <Button type="primary" onClick={changeOrdersToUnassigned}>
                    {t('addOrdersToDate')}
                    <ReactSVG className="icon" src="/icons/plus.svg" />
                  </Button>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
      <SwapStopsToDriver
        state={multipleStepState}
        setMultipleStepState={setMultipleStepState}
        handleOk={moveSteps}
        handleCancel={handleCancelMultiStops}
        routes={routes}
        solutions={solutions}
        orders={ordersInDate || []}
      />

      {selectedStep.id && (
        <StopClicked
          item={selectedStep}
          solutions={solutions}
          onStepClick={setSelectedStep}
          allOrders={ordersInDate || []}
        />
      )}
    </Spin>
  );
};
export default RoutesChart;
